import _get from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isString, u8aToU8a } from '@polkadot/util';
import { Raw } from "./Raw.mjs";
/** @internal */

function decodeU8aFixed(value, bitLength) {
  if (Array.isArray(value) || isString(value)) {
    return decodeU8aFixed(u8aToU8a(value), bitLength);
  } // ensure that we have an actual u8a with the full length as specified by
  // the bitLength input (padded with zeros as required)


  var byteLength = bitLength / 8;
  var sub = value.subarray(0, byteLength);

  if (sub.length === byteLength) {
    return sub;
  }

  var u8a = new Uint8Array(byteLength);
  u8a.set(sub, 0);
  return u8a;
}
/**
 * @name U8aFixed
 * @description
 * A U8a that manages a a sequence of bytes up to the specified bitLength. Not meant
 * to be used directly, rather is should be subclassed with the specific lengths.
 */


export var U8aFixed =
/*#__PURE__*/
function (_Raw) {
  _inherits(U8aFixed, _Raw);

  function U8aFixed(registry) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Uint8Array();
    var bitLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 256;

    _classCallCheck(this, U8aFixed);

    return _possibleConstructorReturn(this, _getPrototypeOf(U8aFixed).call(this, registry, decodeU8aFixed(value, bitLength)));
  }

  _createClass(U8aFixed, [{
    key: "toRawType",

    /**
     * @description Returns the base runtime type name for this instance
     */
    value: function toRawType() {
      return "[u8;".concat(this.length, "]");
    }
  }], [{
    key: "with",
    value: function _with(bitLength, typeName) {
      return (
        /*#__PURE__*/
        function (_U8aFixed) {
          _inherits(_class, _U8aFixed);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, value, bitLength));
          }

          _createClass(_class, [{
            key: "toRawType",
            value: function toRawType() {
              return typeName || _get(_getPrototypeOf(_class.prototype), "toRawType", this).call(this);
            }
          }]);

          return _class;
        }(U8aFixed)
      );
    }
  }]);

  return U8aFixed;
}(Raw);